<template>
	<div>
	</div>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {};
  },
  methods: {
  },
  mounted() {
    this.goUrl('/')
  },
  created() {
  }
};
</script>
<style scoped>
</style>
